import toast from 'react-hot-toast'
import { Toast, ToastProps } from './Toast'

export const displayToast = (
  variant: ToastProps['variant'],
  title: string,
  description: string
) => {
  toast.custom((t) => (
    <Toast description={description} t={t} title={title} variant={variant} />
  ))
}
